import { useTranslationResponse as t } from '@isomorphic/hooks/use-translation-response';

export const usePlatformsTranslations = () => ({
  [t('403PlayStation5')]: [
    {
      text: t('403SignInto'),
      linkUrl: 'https://partners.playstation.net/',
      key: '403SignInto',
    },
    {
      text: t('403GoPlayStation'),
      key: '403GoPlayStation',
    },
    {
      text: t('403LetUsKnow'),
      linkUrl: 'https://eoshelp.epicgames.com/s/console-access-request',
      key: '403LetUsKnow',
    },
  ],
  [t('403PlayStation4')]: [
    {
      text: t('403VisitTools'),
      linkUrl: 'https://ps4.siedev.net/tm/verify/epic_games',
      key: '403VisitTools',
    },
    {
      text: t('403LocateEpicGames'),
      key: '403LocateEpicGames',
    },
    {
      text: t('403ConfirmStatus'),
      linkUrl: 'https://eoshelp.epicgames.com/s/console-access-request',
      key: '403ConfirmStatus',
    },
  ],
  [t('403Xbox')]: [
    {
      text: t('403ContactMicrosoft'),
      linkUrl: 'mailto:consoles@unrealengine.com',
      key: '403ContactMicrosoft',
    },
    {
      text: t('403ConfirmStatusMicrosoft'),
      linkUrl: 'https://eoshelp.epicgames.com/s/console-access-request',
      key: '403ConfirmStatusMicrosoft',
    },
  ],
  [t('403Nintendo')]: [
    {
      text: t('403NintendoLogin'),
      linkUrl: 'https://developer.nintendo.com/',
      key: '403NintendoLogin',
    },
    {
      text: t('403NintendoRequest'),
      key: '403NintendoRequest',
    },
    {
      text: t('403NintendoSwitch'),
      key: '403NintendoSwitch',
    },
    {
      text: t('403NintendoLetUsKnow'),
      linkUrl: 'https://eoshelp.epicgames.com/s/console-access-request',
      key: '403NintendoLetUsKnow',
    },
  ],
  [t('403Nintendo2')]: [
    {
      text: t('403Nintendo2Login'),
      linkUrl: 'https://developer.nintendo.com/',
      key: '403Nintendo2Login',
    },
    {
      text: t('403Nintendo2Request'),
      key: '403Nintendo2Request',
    },
    {
      text: t('403Nintendo2Switch'),
      key: '403Nintendo2Switch',
    },
    {
      text: t('403Nintendo2LetUsKnow'),
      linkUrl: 'https://eoshelp.epicgames.com/s/console-access-request',
      key: '403Nintendo2LetUsKnow',
    },
  ],
});
